import './style/Search.css'

import React from 'react'

function Search() {
  return (
    <div className='container'>
        <br /><br />
        <div className="search-info">
          <h4 className='scs'>silentCosmicSorry..,</h4>
        <p>Search function is under development stage </p>
        
        <p className='patience'>Thank you for your patience :) </p>
        <div className="search">

        </div>
        </div>
        
    </div>
  )
}

export default Search